import React from "react";
import { BrowserRouter, Route } from "react-router-dom";
import App from "./App";

const BaseRouter = () => (
  <BrowserRouter>
    <Route component={App} />
  </BrowserRouter>
);

export default BaseRouter;



// WEBPACK FOOTER //
// ./src/AppRouter.js